// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUpOutlinedSvg from "@fishx/icons-svg/es/asn/PUpOutlined";
import FishxIcon from '../components/FishxIcon';

var PUpOutlined = function PUpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUpOutlinedSvg
  }));
};

PUpOutlined.displayName = 'PUpOutlined';
export default React.forwardRef(PUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUpOutlined.js
// module id = 3705
// module chunks = 0